import React from "react";
import "../../App.css";
import NavbarComp from "../navbar/navbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";

class HireMe extends React.Component {
  render() {
    const POSITION = "Senior Software Engineer | Backend & Distributed Systems";
    const EMAIL = "chavansubhed@gmail.com";
    const PHONE_DISPLAY = "+1 530-715-5858";
    const PHONE_TEL = "+15307155858";
    const RESUME_URL = "/resume/Subhed_Chavan.pdf";

    return (
      <div className="container d-flex justify-content-center mt-5">
        <div className="centered-box w-lg-75 w-100">
          <NavbarComp />

          <div className="hire-page">
            <section className="hire-hero">
              <div className="home-kicker">
                <span>Open to senior engineering roles</span>
                <span>Backend · Cloud · DevOps</span>
              </div>

              <div className="hire-heading-row">
                <div>
                  <p>{POSITION}</p>
                </div>

                <div className="home-actions hire-actions">
                  <a className="home-primary-link" href={`mailto:${EMAIL}`}>
                    Contact me
                  </a>
                  <a className="home-secondary-link" href={RESUME_URL} download>
                    Download resume
                  </a>
                </div>
              </div>

              <p className="home-intro hire-intro">
                I bring production backend ownership, infrastructure automation,
                and delivery-focused DevOps experience to teams building
                reliable, scalable software systems.
              </p>

              <div className="hire-contact-row">
                <a href={`mailto:${EMAIL}`}>
                  <FontAwesomeIcon icon={faEnvelope} />
                  {EMAIL}
                </a>
                <a href={`tel:${PHONE_TEL}`}>
                  <FontAwesomeIcon icon={faPhone} />
                  {PHONE_DISPLAY}
                </a>
              </div>
            </section>

            <section className="hire-resume-section">
              <div className="hire-section-heading">
                <h5>Resume Preview</h5>
                <a href={RESUME_URL} target="_blank" rel="noreferrer">
                  Open PDF
                </a>
              </div>

              <iframe
                src={RESUME_URL}
                title="Resume Preview"
                className="hire-resume-frame"
              />
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default HireMe;
